import Infothek from "./infothek";

customElements.define("infothek-wrapper", Infothek);
